<template>
  <div class='convert-slide-box'>
    <div class='slide-toggle' @click="slideToggle()">
      <div class="title">成功兑换用户</div>
      <div
        v-if="productInfo.BuyUserList && productInfo.BuyUserList.length > 2"
        class="detail-allow-right"
        :class="[convertOpen ? 'rotate-45' : '']">
      </div>
    </div>
    <template v-if="productInfo.BuyUserList && productInfo.BuyUserList.length > 0">
      <slide-scroll
        v-if="!convertOpen && productInfo.BuyUserList.length > 2"
        :page-count="Math.ceil(productInfo.BuyUserList.length / 2)"
        :speed="5000"
        :loop="true"
        :slide-height="92">
          <div class="buy-user-list">
            <div class="buy-user-item" v-for="(item, index) in scollUserList" :key="index">
              <div class="buy-user-img">
                <div class="img"><img v-lazy="item.HeadPortraitUrl" alt=""></div>
                <div>{{item.Nick | filterNikeName}}&nbsp;
                  <template>获得了购买机会</template>
                </div>
              </div>
              <span v-if="item.TotalSeconds">{{item.TotalSeconds | filterConverTime}}</span>
            </div>
          </div>
      </slide-scroll>
      <div class="buy-user-list" v-if="convertOpen || productInfo.BuyUserList.length <= 2">
        <div class="buy-user-item" v-for="(item, index) in productInfo.BuyUserList" :key="index">
          <div class="buy-user-img">
            <div class="img"><img v-lazy="item.HeadPortraitUrl" alt=""></div>
            <div>{{item.Nick | filterNikeName}}&nbsp;
              <template>获得了购买机会</template>
            </div>
          </div>
          <span v-if="item.TotalSeconds">{{item.TotalSeconds | filterConverTime}}</span>
        </div>
      </div>
    </template>
    <div class="list-cell-none" v-else>暂时还没有用户兑换成功~</div>
  </div>
</template>

<script>
import SlideScroll from './SlideScroll'

export default {
  data () {
    return {
      convertOpen: false
    }
  },
  props: {
    productInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    scollUserList: {
      type: Array,
      default: () => []
    }
  },
  components: { SlideScroll },
  methods: {
    slideToggle () {
      this.convertOpen = !this.convertOpen
    }
  },
  filters: {
    filterNikeName (val) {
      if (!val) return '----'
      if (val.length > 4) {
        return val.substring(0, 4) + '...'
      } else {
        return val
      }
    },
    filterConverTime (val) {
      if (!val) return ''
      if (val > 24 * 60 * 60) {
        return `1天前`
      } else if (val > 60 * 60) {
        return `${Math.floor(val / (60 * 60))}小时前`
      } else if (val > 60) {
        return `${Math.floor(val / 60)}分钟前`
      } else {
        return `${val}秒前`
      }
    }
  }
}
</script>

<style scoped>
  .convert-slide-box{
    margin-top: 3%;
    background: #ffffff;
  }
  .convert-slide-box .slide-toggle{
    position: relative;
    display: flex;
    justify-content: space-between;
    padding:3% 4%;
    box-sizing: border-box;
    border-bottom: 1px solid #f2f2f2;
    transition: 0.3s;
  }
  .slide-toggle .title{
    font-size: 15px;
  }
  .detail-allow-right{
    border: 2px solid #c8c8cd;
    border-bottom-width: 0;
    border-left-width: 0;
    content: " ";
    top: 50%;
    right: 20px;
    position: absolute;
    width: 5px;
    height: 5px;
    transform: translateY(-50%) rotate(135deg);
  }
  .rotate-45 {
    transform: rotate(-45deg);
    transition: 0.4s linear 0s;
  }
  /* list */
  .buy-user-list{
    box-sizing: border-box;
  }
  .buy-user-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    color: #777;
    margin: 0 4%;
    border-bottom: 1px solid #eee;
  }
  .buy-user-item:last-child{border-bottom: none;}
  .buy-user-img{
    display: flex;
    align-items: center;
  }
  .buy-user-img .img{
    height: 35px;
    width: 35px;
    margin-right: 10px;
  }
  .buy-user-img .img img{
    height: 100%;
    width: 100%;
    border-radius: 50%;
  }
  .list-cell-none{
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #999;
    font-size: 14px;
  }
</style>
